import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useHistory } from 'react-router-dom';

import { forgotPassword, clearAuthErrors } from '../../redux/auth/auth.actions';
import { selectAuthStatusForgotPassword, selectAuthLoading, selectAuthErrors } from '../../redux/auth/auth.selectors';

import LoaderSimple from '../../components/Loaders/LoaderSimple/LoaderSimple';
import AuthErrorAlert from './AuthError/AuthErrorAlert';

import Logo2 from '../../components/Logo/Logo2';

import './Auth.scss';


const getEncodedValue = (value) => {
    let encodedValue = '';
    try {
        if (value) {
            encodedValue = atob(value) || '';
        }
    } catch (e) {
        encodedValue = '';
    }
    return encodedValue;
}

const ForgotPassword = () => {
    document.title = 'Forgot Password - DB Design';

    const dispatch = useDispatch();
    const location = useLocation();
    const history = useHistory();

    const authStatusForgotPassword = useSelector(selectAuthStatusForgotPassword);
    const isAuthLoading = useSelector(selectAuthLoading);
    const authError = useSelector(selectAuthErrors);

    const queryParams = new URLSearchParams(location.search);
    const stateParam = queryParams.get('state');
    let defaultEmail = getEncodedValue(stateParam);

    const [email, setEmail] = useState(defaultEmail || '');

    const inputEmailRef = useRef(null);
    const [isLoadingForgotPass, setIsLoadingForgotPass] = useState(false);

    const [isInvalidEmail, setIsInvalidEmail] = useState(false);
    const [isValidationStarted, setIsValidationStarted] = useState(false);

    const setValidationLoading = () => {
        setIsLoadingForgotPass(true);
        setIsInvalidEmail(false);
        setTimeout(() => {
            setIsLoadingForgotPass(false);
            setIsInvalidEmail(true);
            if (!isValidationStarted) {
                setIsValidationStarted(true);
            }
            inputEmailRef.current.focus();
        }, 300);
    }

    const handleEmailChange = (event) => {
        if (isValidationStarted) {
            handleEmailValidation(event.target.value);
        }
        setEmail(event.target.value);
    }
    const handleSubmit = () => {
        if (validateEmail(email)) {
            setIsLoadingForgotPass(true);
            setTimeout(() => {
                setIsLoadingForgotPass(false);
                dispatch(forgotPassword({ email, redirectTo: '/' }));
            }, 200);
        } else {
            setValidationLoading();
        }
    }

    const handleEmailValidation = (emailValue) => {
        setIsInvalidEmail(!validateEmail(emailValue));
    }
    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleSubmit();
        }
    };

    useEffect(() => {
        document.title = 'Forgot Password - DB Design';
    }, []);

    useEffect(() => {
        if (isInvalidEmail) {
            inputEmailRef.current.focus();
        }
    }, [isInvalidEmail]);

    useEffect(() => {
        inputEmailRef.current.focus();
    }, [isAuthLoading]);

    useEffect(() => {
        if (authStatusForgotPassword) {
            const url = `/check-email?type=reset-password&email=${email}`;
            history.push(url);
        }
    }, [authStatusForgotPassword]);

    const validateEmail = (emailValue) => {
        const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return regex.test(emailValue);
    };

    const handleBackClick = () => {
        // const stateValue = email ? btoa(email) : '';
        // const url = stateValue ? `/login?state=${btoa(email)}` : '/login';
        const url = '/login';
        setTimeout(() => {
            history.push(url);
            dispatch(clearAuthErrors());
        }, 100);
    };

    return (
        <div className="sign-in-box">
            <Logo2 />
            <div className="sign-in-blur"></div>

            <div className={`sign-in-wrap ${authError ? 'error' : ''}`}>
                <div className={`sign-in`}>

                    {authError
                        ? <AuthErrorAlert isAuthLoading={isAuthLoading} error={authError} />
                        : ''}

                    <div className="sign-in-title">Forgot password?</div>
                    <input
                        maxLength="150"
                        ref={inputEmailRef}
                        className={`auth-input ${isInvalidEmail ? 'auth-input-invalid' : ''}`}
                        name="email"
                        type="email"
                        value={email}
                        disabled={isLoadingForgotPass || isAuthLoading}
                        autoFocus={(window.innerWidth >= 1000)}
                        autoComplete="off"
                        autoCorrect="off"
                        autoCapitalize="off"
                        spellCheck="false"
                        inputMode="email"
                        placeholder="Enter your email address"
                        aria-label="Enter your email address"
                        onChange={handleEmailChange}
                        onKeyDown={handleKeyPress}
                    ></input>
                    {isInvalidEmail ? <p className='auth-validation-text'>Please enter a valid email address.</p> : ''}

                    <button
                        disabled={isLoadingForgotPass || isAuthLoading}
                        className="auth-btn-submit s_forgot"
                        type="submit"
                        onClick={handleSubmit}
                    >{isLoadingForgotPass || isAuthLoading ? <LoaderSimple /> : 'Send me a reset link'}</button>

                    <button
                        className="auth-btn-back"
                        type="button"
                        onClick={handleBackClick}
                    >Back</button>
                </div>
            </div>
        </div>
    )
};

export default ForgotPassword;
